var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useForm, } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
export var Form = function (_a) {
    var schema = _a.schema, defaultValues = _a.defaultValues, onSubmit = _a.onSubmit, _b = _a.mode, mode = _b === void 0 ? "onSubmit" : _b, _c = _a.reValidateMode, reValidateMode = _c === void 0 ? "onSubmit" : _c, _d = _a.criteriaMode, criteriaMode = _d === void 0 ? "all" : _d, children = _a.children;
    var methods = useForm({
        mode: mode,
        reValidateMode: reValidateMode,
        criteriaMode: criteriaMode,
        resolver: yupResolver(schema),
        defaultValues: defaultValues,
    });
    return (_jsx("form", __assign({ onSubmit: methods.handleSubmit(onSubmit) }, { children: children(methods) })));
};
